import { Box, Button, Typography, useTheme } from "@mui/material";
// import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../theme";
// import { mockDataTeam } from "../../data/mockData";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import LockOpenOutlinedIcon from "@mui/icons-material/LockOpenOutlined";
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined";
import Header from "../../components/Header";
import EditIcon from '@mui/icons-material/Edit';
import { Link } from 'react-router-dom';

const Team = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const columns = [
        { field: "id", headerName: "ID" },
        {
            field: "name",
            headerName: "Name",
            flex: 1,
            cellClassName: "name-column--cell",
        },
        {
            field: "age",
            headerName: "Age",
            type: "number",
            headerAlign: "left",
            align: "left",
        },
        {
            field: "phone",
            headerName: "Phone Number",
            flex: 1,
        },
        {
            field: "email",
            headerName: "Email",
            flex: 1,
        },
        {
            field: "accessLevel",
            headerName: "Access Level",
            flex: 1,
            renderCell: ({ row: { access } }) => {
                return (
                    <Box
                        width="60%"
                        m="0 auto"
                        p="5px"
                        display="flex"
                        justifyContent="center"
                        backgroundColor={
                            access === "admin"
                                ? colors.greenAccent[600]
                                : access === "manager"
                                    ? colors.greenAccent[700]
                                    : colors.greenAccent[700]
                        }
                        borderRadius="4px"
                    >
                        {access === "admin" && <AdminPanelSettingsOutlinedIcon />}
                        {access === "manager" && <SecurityOutlinedIcon />}
                        {access === "user" && <LockOpenOutlinedIcon />}
                        <Typography color={colors.grey[100]} sx={{ ml: "5px" }}>
                            {access}
                        </Typography>
                    </Box>
                );
            },
        },
    ];

    return (
        <Box m="20px">
            <Box display="flex" justifyContent="space-between" alignItems="center">
                <Header title="PASSPORT PAYMENT" subtitle="Managing the Passport Payment List" />

                {/* <Box>
                    <Button
                        sx={{
                            backgroundColor: colors.blueAccent[700],
                            color: colors.grey[100],
                            fontSize: "14px",
                            fontWeight: "bold",
                            padding: "10px 20px",
                        }} data-bs-toggle="modal" data-bs-target="#exampleModal" className="text-white"
                    >
                        <Link to="/createvisitor" color="secondary" className="text-decoration-none text-white">
                        + Create Hajj Package
                        </Link>
                    </Button>
                </Box> */}
            </Box>
            <Box
                m="40px 0 0 0"
                height="75vh"
                sx={{
                    "& .MuiDataGrid-root": {
                        border: "none",
                    },
                    "& .MuiDataGrid-cell": {
                        borderBottom: "none",
                    },
                    "& .name-column--cell": {
                        color: colors.greenAccent[300],
                    },
                    "& .MuiDataGrid-columnHeaders": {
                        backgroundColor: colors.blueAccent[700],
                        borderBottom: "none",
                    },
                    "& .MuiDataGrid-virtualScroller": {
                        backgroundColor: colors.primary[400],
                    },
                    "& .MuiDataGrid-footerContainer": {
                        borderTop: "none",
                        backgroundColor: colors.blueAccent[700],
                    },
                    "& .MuiCheckbox-root": {
                        color: `${colors.greenAccent[200]} !important`,
                    },
                }}
            >
                {/* <DataGrid checkboxSelection rows={mockDataTeam} columns={columns} /> */}
                <div class="table-responsive">
                    <table class="table table-dark">
                        <thead>
                            <tr>

                                <th>S No.</th>
                                <th scope="col">Name</th>
                                <th scope="col">Agent Name</th>
                                <th scope="col">Phone No.</th>
                                <th scope="col">Passport No.</th>
                                <th scope="col">Admission Fee</th>
                                <th scope="col">Paid Amount</th>
                                <th scope="col">Due Amount</th>
                                <th scope="col">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>1</td>
                                <td>Lorem</td>
                                <td>Ipsum</td>
                                <td>22222222</td>
                                <td>623fgh4</td>
                                <td>222</td>
                                <td>2222</td>
                                <td>0</td>
                                <td ><EditIcon /></td>
                            </tr>

                            <tr>
                                <td>2</td>
                                <td>Lorem</td>
                                <td>Ipsum</td>
                                <td>22222222</td>
                                <td>623fgh4</td>
                                <td>222</td>
                                <td>2222</td>
                                <td>0</td>
                                <td ><EditIcon /></td>
                            </tr>
                            <tr>
                                <td>3</td>
                                <td>Lorem</td>
                                <td>Ipsum</td>
                                <td>22222222</td>
                                <td>623fgh4</td>
                                <td>222</td>
                                <td>2222</td>
                                <td>0</td>
                                <td ><EditIcon /></td>
                            </tr>
                            <tr>
                                <td>4</td>
                                <td>Lorem</td>
                                <td>Ipsum</td>
                                <td>22222222</td>
                                <td>623fgh4</td>
                                <td>222</td>
                                <td>2222</td>
                                <td>0</td>
                                <td ><EditIcon /></td>
                            </tr>
                            <tr>
                                <td>5</td>
                                <td>Lorem</td>
                                <td>Ipsum</td>
                                <td>22222222</td>
                                <td>623fgh4</td>
                                <td>222</td>
                                <td>2222</td>
                                <td>0</td>
                                <td ><EditIcon /></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">User</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                Comapny Name:<br />
                                Address:<br />
                                Subscription Package:
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                <button type="button" className="btn btn-primary">Save changes</button>
                            </div>
                        </div>
                    </div>
                </div>
            </Box>
        </Box>

    );
};

export default Team;
